module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av501-5fb67365e57e25506d017cf3ed0713da.jpg";